import EditTierContainer from './EditTier.container';
import EditTier from './EditTier';
export default EditTierContainer(EditTier);
//# sourceMappingURL=index.js.map